<template>
    <div>
        <el-dialog title="新增推荐" :visible.sync="visible" width="500px">
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="选择商品" prop="goods_uuid">
                    <el-button type="text" @click="handlePick">选择商品</el-button>
                    <el-tag v-if="goodsName" style="margin-left: 20px">{{ goodsName }}</el-tag>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input placeholder="请输入排序" v-model="form.sort" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="handleConfirm">确 定</el-button>
            </div>
        </el-dialog>
        <GoodsPicker ref="goodsPicker" @pick="pick"></GoodsPicker>
    </div>
</template>

<script>
import GoodsPicker from "@/components/GoodsPicker";
import { add } from "@/api/product/recommend";
export default {
    components: { GoodsPicker },
    data() {
        return {
            visible: false,
            form: {
                goods_uuid: "",
                sort: "",
            },
            goodsName: "",
            rules: {
                goods_uuid: [{ required: true, message: "请选择商品" }],
                sort: [{ required: true, message: "请输入排序" }],
            },
        };
    },
    methods: {
        open() {
            this.visible = true;
            this.form.goods_uuid = "";
            this.form.sort = "";
			this.goodsName = "";
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        handlePick() {
            this.$refs.goodsPicker.open();
        },
        pick(data) {
            this.form.goods_uuid = data.uuid;
            this.goodsName = data.name;
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                add(this.form).then(({ code, error }) => {
                    if (code === 200) {
                        this.$message.success("新增成功");
                        this.visible = false;
                        this.$emit("update");
                    } else {
                        this.$message.error(error.message);
                    }
                });
            });
        },
    },
};
</script>

<style></style>
